import type { ResourceProps } from '@refinedev/core'

export const resources = [
	{
		name: 'recipes',
		identifier: 'products', // alias
	},
	{
		name: 'sites',
		identifier: 'store_cabinets',
	},
	{
		name: 'vouchers',
		identifier: 'promotions',
	},
	{
		name: 'inventory_summary',
	},
	{
		name: 'health-alerts',
	},
	{
		name: 'user-notifications',
	},
] satisfies ResourceProps[]
